import React from 'react';
import propTypes from 'prop-types';
import css from 'classnames';
import useWidgetLayout from '../../hooks/useWidgetLayout';

import styles from './results.module.css';

const FormResults = (props) => {
  const orientation = useWidgetLayout();
  const { handleResetForm, result } = props;
  const imageAltText = (result) => `${result.make} ${result.model} image`;

  return (
    <div className={css([styles.resultsContainer, styles[orientation]])}>
      <div className={styles.resultsImageContainer}>
        <div className={styles.resultsImageImage}>
          <img src={result.image} alt={imageAltText(result)} />
        </div>
        <a className={styles.link} href='#' onClick={(e) => handleResetForm(e)}>
          Reset calculator
        </a>
      </div>
      <div className={styles.resultsHeadingContainer}>
        <h2 className={styles.resultsHeading}>
          {`${result.make} ${result.model}`}
        </h2>
        <p className={styles.resultsTagline}>{result.version}</p>
      </div>
      <div className={styles.resultsTableContainer}>
        <table className={styles.resultsTable}>
          <tbody>
            {Object.values(result.tableData).map((row, index) => {
              return (
                row && (
                  <tr key={`row-${index}`}>
                    <td>{row.label}</td>
                    <td>{row.value}</td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

FormResults.propTypes = {
  handleResetForm: propTypes.func,
  result: propTypes.object, // TODO: need to be more granular
};

export default FormResults;
